<template>
  <div
    v-if="isFreeOrSignedOut"
    class="container padding-y-md"
  >
    <div
      class="display-flex flex-items-center flex-wrap tablet:align-between padding-y-md padding-x-xl"
      style="gap: var(--spacing-md); background-color: var(--fa-yellow); border-radius: var(--border-radius-lg); --link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
    >
      <p
        class="text-left margin-y-0"
        style="flex: 1 1 20rem"
      >
        <font-awesome-icon
          :icon="$v7.solid.faSun"
          size="lg"
          class="margin-right-xs"
          aria-hidden="true"
        />
        <!-- $4/mo is the annual Starter rate (FA-STARTER, $48/yr). -->
        <site-link
          :to="{ name: 'plans' }"
          class="strong"
          @click="trackClick('headline')"
          >Plans starting at $4/mo.</site-link
        >
        Pro icons, Kits, and the Icon Wizard, hosted on our CDN.
      </p>
      <site-link
        :to="{ name: 'plans' }"
        @click="trackClick('see_plans_link')"
        >See&nbsp;plans&nbsp;&rarr;</site-link
      >
    </div>
  </div>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'PlanPricingNotice',

    mixins: [EventTrackingMixin],

    computed: {
      isFreeOrSignedOut() {
        return !this.$dt?.hasActivePaidSubscription && !this.$dt?.isBacker
      }
    },

    methods: {
      trackClick(location) {
        this.purchaseFlowEvent('get_pro_button_click', { context: 'plan_pricing_notice', location })
      }
    }
  }
</script>
